import { Modal, ModalBody } from 'reactstrap'
import Lottie from 'react-lottie'
import * as animationData from '../assets/76705-error-animation.json'

const ErrorModal = ({ isVisible, onClose, message }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div>
      <Modal centered isOpen={isVisible} toggle={onClose}>
        <ModalBody
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            lineHeight: 1,
          }}
        >
          <div style={{ with: '100%', marginBottom: '1rem', marginTop: '0.5rem' }}>
            <Lottie options={defaultOptions} height={75} width={75} />
          </div>
          <p
            style={{
              fontWeight: 'bolder',
              fontSize: 25,
            }}
          >
            {'Uyarı'}
          </p>
          <div style={{ textAlign: 'center' }}>
            <p>{message}</p>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default ErrorModal
